import * as Yup from "yup";

export const menuSchema = Yup.object().shape({
  name: Yup.string().trim().required("Menu name is required"),
  route: Yup.string()
    .trim()
    .when("parent_id", {
      is: (parentId: string) => Boolean(parentId) && parentId !== "0",
      then: (schema) =>
        schema.required("Route is required when parent menu is selected"),
      otherwise: (schema) => schema,
    }),
  icon: Yup.string().trim(),
  parent_id: Yup.string().required("Parent menu is required"),
  sort_order: Yup.number()
    .typeError("Sort order must be a number")
    .min(0, "Sort order cannot be negative")
    .required("Sort order is required"),
  is_default: Yup.string().required("Default value is required"),
  status: Yup.string().required("Status is required"),
});
